import { render, staticRenderFns } from "./GroupTotal.vue?vue&type=template&id=bc9e1862&scoped=true"
import script from "./GroupTotal.vue?vue&type=script&lang=js"
export * from "./GroupTotal.vue?vue&type=script&lang=js"
import style0 from "./GroupTotal.vue?vue&type=style&index=0&id=bc9e1862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e1862",
  null
  
)

export default component.exports